import * as yup from "yup";

/** The new-case wizard's client step (`features/newCase`). */
export const newClientFormSchema = yup.object({
  firstName: yup.string().trim().required("First name is required"),
  middleName: yup.string(),
  lastName: yup.string().trim().required("Last name is required"),
  title: yup.string(),
  pronouns: yup.string(),
  birthday: yup.string(),
  email: yup
    .string()
    .email("Please enter a valid email")
    .required("Email is required"),
  phone: yup.string(),
  assignedUserIds: yup.array().of(yup.string().required())
});

export type NewClientFormValues = {
  firstName: string;
  middleName: string;
  lastName: string;
  title: string;
  pronouns: string;
  birthday: string;
  email: string;
  phone: string;
  assignedUserIds: string[];
};
